/**
 * @generated SignedSource<<5039c27df0f6ad2d2939e0a9a8e3c20a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type EmployeeShiftStatus = "ACTIVE" | "PAST" | "UPCOMING";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
import { FragmentRefs } from "relay-runtime";
export type WidgetEmployeeSchedule_widgetEmployeeSchedule$data = {
  readonly employeesWithShifts: ReadonlyArray<{
    readonly id: string;
    readonly shifts: ReadonlyArray<{
      readonly status: EmployeeShiftStatus;
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"EmployeeScheduleShiftsEmployee_employee">;
  }>;
  readonly id: string;
  readonly overviewSize: WidgetOverviewSize;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeScheduleIcon_widgetEmployeeSchedule">;
  readonly " $fragmentType": "WidgetEmployeeSchedule_widgetEmployeeSchedule";
};
export type WidgetEmployeeSchedule_widgetEmployeeSchedule$key = {
  readonly " $data"?: WidgetEmployeeSchedule_widgetEmployeeSchedule$data;
  readonly " $fragmentSpreads": FragmentRefs<"WidgetEmployeeSchedule_widgetEmployeeSchedule">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WidgetEmployeeSchedule_widgetEmployeeSchedule",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "overviewSize",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WidgetEmployeeScheduleIcon_widgetEmployeeSchedule"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employeesWithShifts",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "EmployeeShift",
          "kind": "LinkedField",
          "name": "shifts",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "EmployeeScheduleShiftsEmployee_employee"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "WidgetEmployeeSchedule",
  "abstractKey": null
};
})();

(node as any).hash = "0b958205dd54ffaea0cd99c3296e2412";

export default node;
